import { render, staticRenderFns } from "./PoshPolicy.vue?vue&type=template&id=6b5653c6&scoped=true&"
import script from "./PoshPolicy.vue?vue&type=script&lang=js&"
export * from "./PoshPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PoshPolicy.vue?vue&type=style&index=0&id=6b5653c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5653c6",
  null
  
)

export default component.exports